module.exports = __webpack_public_path__ + "assets/img/mecha-btn-52135e6b.png";